import Vue from 'vue'
import VueRouter from 'vue-router'
import layout from '@/layout'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: layout,
    children: [
      {
        path: '/experiences',
        name: 'experiences',
        component: () => import('@/views/experiences/list.vue')
      },
      {
        path: '/experiences/:id',
        name: 'experiences-details',
        component: () => import('@/views/experiences/details.vue')
      },
      {
        path: '/developers',
        name: 'developers',
        component: () => import('@/views/developers/list.vue')
      },
      {
        path: '/developers/:id',
        name: 'developers-details',
        component: () => import('@/views/developers/details.vue')
      },
      {
        path: '/universities',
        name: 'universities',
        component: () => import('@/views/universities/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  //  mode: 'hash',
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach(async (to, from, next) => {
//   console.log(111)
//   next()
// })

export default router
